module.exports = __webpack_public_path__ + "static/media/service-list-desktop.72f7f92e.jpg";